import './Template';
import './slider';

import '../scss/main.scss';
